export const ROUTES = ({ agreementType, createAs }) => [
  {
    label: 'special_billing.review-billing-agreement',
    link: '',
  },
  {
    label: 'special-billing-agreements',
    link: 'additional-functionalities/special-billing',
  },
  {
    label: 'additional_functionalities',
    link: 'additional-functionalities',
  },
];
